var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { ref: "colorpicker", staticClass: "input-group color-picker" },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.valueCopy,
                expression: "valueCopy",
              },
            ],
            staticClass: "form-control",
            class: _vm.inputClasses,
            attrs: {
              type: "text",
              name: _vm.name,
              id: _vm.id,
              placeholder: _vm.placeholder,
              readonly: _vm.readonly,
              disabled: _vm.disabled,
              autocomplete: _vm.autocomplete,
              required: _vm.required,
            },
            domProps: { value: _vm.valueCopy },
            on: {
              focus: function ($event) {
                return _vm.handleFocus(true)
              },
              blur: function ($event) {
                return _vm.handleFocus(false)
              },
              input: [
                function ($event) {
                  if ($event.target.composing) return
                  _vm.valueCopy = $event.target.value
                },
                _vm.handleModelInput,
              ],
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "material-label",
              class: _vm.activeClass,
              attrs: { for: _vm.id },
            },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "input-group-append color-picker-container" },
            [
              _c("span", {
                staticClass: "input-group-text current-color",
                style: "background-color: " + _vm.valueCopy,
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    !_vm.disabled && _vm.togglePicker()
                  },
                },
              }),
              _vm._v(" "),
              _vm.displayPicker
                ? _c("chrome-picker", {
                    attrs: { value: _vm.colors },
                    on: { input: _vm.updateFromPicker },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("help-span", { attrs: { helpText: _vm.helpText } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }